import { logger } from "../utils/logger";
/*
  故障管理一覧表: IH-BUG-199
  対応日: 2026/3/26
  担当者: 越智
  修正概要: 未読件数
*/
import React, { createContext, useContext, useEffect, useRef } from "react";
/*
  END
  故障管理一覧表: IH-BUG-199
*/
import { generateClient } from "aws-amplify/api";
import { useUnreadCount } from "../hooks/useUnreadCount";
import {
  SUBSCRIBE_ROOM_LIST_FOR_EMPLOYEE,
  SUBSCRIBE_ROOM_LIST_FOR_ORGANIZATION,
} from "../api/graphql/chatGraphQL";
import { useAuth } from "../hooks/useAuth";
/*
課題・障害番号: IH-BUG-513
対応日: 2026/05/21
担当者: 小林
修正概要: 自身の管理者情報更新時に未読データを再取得させるためのイベント名を取り込み
*/
import { CUSTOM_EVENT } from "../constants/Constants";
/*
END
課題・障害番号: IH-BUG-513
*/

const UnreadContext = createContext();

/*
  残課題: 固定値になっていた
  対応日: 2026/3/25
  担当者: 越智
  修正概要: 自身の企業を取得し設定
*/
export const UnreadProvider = ({ children }) => {
  const { unreadData, isLoading, fetchUnread } = useUnreadCount();
  /*
  未読件数対応:
  対応日: 2026/04/13
  担当者: 越智
  修正概要: システム管理者で未読取得しようとしていた
  */
  const { userId, identifyId, isAdmin, isSystemManagement } = useAuth();

  /*
  END
  未読件数対応:
  */

  const userType = isAdmin ? "organization" : "employee";

  const subscriptionRef = useRef(null); // サブスク保持用

  // サブスク登録の実体を関数として定義
  const setupRoomListSubscription = () => {
    try {
      if (subscriptionRef.current) subscriptionRef.current.unsubscribe();

      const isEmployee = userType === "employee";

      const query = isEmployee
        ? SUBSCRIBE_ROOM_LIST_FOR_EMPLOYEE
        : SUBSCRIBE_ROOM_LIST_FOR_ORGANIZATION;

      const variables = isEmployee
        ? { send_id: String(userId) }
        : { organization_id: Number(identifyId) };

      if (!variables.send_id && !variables.organization_id) return;

      subscriptionRef.current = client.graphql({ query, variables }).subscribe({
        next: ({ data }) => {
          const now = Date.now();
          if (now - lastFetchTimeRef.current < 2000) return;
          const updatedRoom = isEmployee
            ? data?.subscribeRoomListForEmployee
            : data?.subscribeRoomListForOrganization;
          if (updatedRoom) {
            lastFetchTimeRef.current = now;
            fetchUnread(userType);
          }
        },
        error: (error) => logger.error("Room List Subscription Error:", error),
      });
    } catch (err) {
      logger.error("Setup Failed:", err);
    }
  };

  const handleLoginSuccess = () => {
    /*
  未読件数対応:
  対応日: 2026/04/13
  担当者: 越智
  修正概要: システム管理者で未読取得しようとしていた
  */
    if (isSystemManagement) return;
    /*
  END
  未読件数対応:
  */

    if (userType) {
      if (userType === "employee") {
        if (!userId) {
          return;
        } // 従業員なのにIDがない
      } else {
        if (!identifyId) {
          return;
        } // 企業側なのにIDがない
      }

      /*
  クリティカル: 企業をまたぐと未読が一瞬前の企業の物となる
  対応日: 2026/04/21
  担当者: 越智
  修正概要: 企業をまたぐと未読が一瞬前の企業の物となる
  */
      const savedUserId = localStorage.getItem("user_id")?.replace(/"/g, "");
      // イベントが飛んできた時、ReactのState(userId)が既に最新なら実行
      if (userId === savedUserId) {
        fetchUnread(userType);
        setupRoomListSubscription();
      }
      /*
  END
  クリティカル: 企業をまたぐと未読が一瞬前の企業の物となる
  */
    }
  };

  useEffect(() => {
    /*
  未読件数対応:
  対応日: 2026/04/13
  担当者: 越智
  修正概要: システム管理者で未読取得しようとしていた
  */
    if (isSystemManagement) return;
    /*
  END
  未読件数対応:
  */

    window.addEventListener("login-success", handleLoginSuccess);
    /*
    課題・障害番号: IH-BUG-513
    対応日: 2026/05/21
    担当者: 小林
    修正概要: 自身の管理者情報（manage_target 含む）更新後に未読を再取得する。
              API 側は manage_target を考慮して未読を返すため、変更直後にキャッシュを更新する必要がある。
    */
    const handleAdminSelfUpdated = () => {
      if (isSystemManagement) return;
      if (!userType) return;
      fetchUnread(userType);
    };
    window.addEventListener(CUSTOM_EVENT.ADMIN_SELF_UPDATED, handleAdminSelfUpdated);
    /*
    END
    課題・障害番号: IH-BUG-513
    */

    if (userId || identifyId) {
      // 以下のどれでもない時は処理しない
      if (
        !window.location.pathname.startsWith("/KenpoWeb") &&
        !window.location.pathname.startsWith("/HospitalWeb") &&
        !window.location.pathname.startsWith("/Employee") &&
        !window.location.pathname.startsWith("/CompanyWeb") &&
        !window.location.pathname.startsWith("/controlpanel")
      ) {
        return;
      }

      /*
      クリティカル: 企業をまたぐと未読が一瞬前の企業の物となる
      対応日: 2026/04/21
      担当者: 越智
      修正概要: 企業をまたぐと未読が一瞬前の企業の物となる
      */
      const savedUserId = localStorage.getItem("user_id");
      // String化して、さらにダブルクォーテーションを置換して消してから比較
      if (String(userId) !== String(savedUserId).replace(/"/g, "")) {
        return;
      }
      /*
      END
      クリティカル: 企業をまたぐと未読が一瞬前の企業の物となる
      */

      fetchUnread(userType);
      setupRoomListSubscription();
    }

    return () => {
      window.removeEventListener("login-success", handleLoginSuccess);
      /*
      課題・障害番号: IH-BUG-513
      対応日: 2026/05/21
      担当者: 小林
      修正概要: 自身の管理者情報更新イベントの listener を解除
      */
      window.removeEventListener(CUSTOM_EVENT.ADMIN_SELF_UPDATED, handleAdminSelfUpdated);
      /*
      END
      課題・障害番号: IH-BUG-513
      */
      if (subscriptionRef.current) subscriptionRef.current.unsubscribe();
    };
  }, [userId, identifyId]);

  /*
    課題・障害番号:  内部実装確認No.186
    対応日: 2026/03/25
    担当者: 飛芸
    修正概要: Amplifyクライアントの初期化をアプリロード完了後に移動
  */
  const client = generateClient();
  /*
    END
    課題・障害番号: 内部実装確認No.186
  */

  /*
    故障管理一覧表: IH-BUG-199
    対応日: 2026/3/26
    担当者: 越智
    修正概要: 未読件数
  */
  const lastFetchTimeRef = useRef(0);
  /*
    END
    故障管理一覧表: IH-BUG-199
  */

  /*
    END
    残課題: 固定値になっていた
  */

  /*
    故障管理一覧表: IH-BUG-199
    対応日: 2026/3/26
    担当者: 越智
    修正概要: 未読件数
  */
  const value = { unreadData, isLoading, fetchUnread };
  /*
    END
    故障管理一覧表: IH-BUG-199
  */

  /*
  故障管理一覧表: IH-BUG-427
  対応日: 2026/04/16
  担当者: 越智
  修正概要: 未読バッジをネイティブのタブに表示
  */
  useEffect(() => {
    // unreadDataが存在し、かつ中身が1つ以上ある場合のみ実行
    if (unreadData && unreadData.length > 0) {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: "UPDATE_UNREAD_DATA",
            payload: unreadData,
          })
        );
      }
    }
  }, [unreadData]);
  /*
  END
  故障管理一覧表: IH-BUG-427
  */

  return <UnreadContext.Provider value={value}>{children}</UnreadContext.Provider>;
};

export const useUnread = () => {
  const context = useContext(UnreadContext);
  if (!context) {
    throw new Error("useUnread must be used within an UnreadProvider");
  }
  return context;
};
